export default "__VITE_ASSET__d9d6db6f__"